import { render, staticRenderFns } from "./ObjectAddressCell.vue?vue&type=template&id=140528c8"
import script from "./ObjectAddressCell.vue?vue&type=script&lang=js"
export * from "./ObjectAddressCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports